import { createSlice } from "@reduxjs/toolkit";


export const newBillingSlice=createSlice({
    name:"newBillingSlice",
    initialState:{
        billingScreen:false,
        productsList:[],
        subCategoryList:undefined,
        paymentTypeList:undefined,
        barCodeList:undefined,
        productType:1,
        barCodeProduct:null,
        authPassWord:"",
        branchConfigurationList:null,
        checkInDetail:null,
        checkInPass:null,
        checkOutPassDetail:null,
        checkOutDetail:null,
        shiftEndtDetail:null
        
    },
    reducers:{
        get_products_list_for_billing:(state,action)=>{
            state.productsList=action.payload.billingProductsList
        },
        get_sub_category_list_for_billing:(state,action)=>{
            state.subCategoryList=action.payload.billingSubCategories
        },
        get_payment_types_list_for_billing:(state,action)=>{
            state.paymentTypeList=action.payload.billingPaymentTypes
        },
        get_barcode_product_list_add_billing:(state,action)=>{
            state.barCodeList=action.payload.barCodeItems
        },
        switch_to_billing_screen:(state,action)=>{
            state.billingScreen=action.payload.billingBoolean
        },
        setCartProductType:(state,action)=>{
            state.productType=action.payload
        },
        setBarcodeProduct:(state,action)=>{
            state.barCodeProduct=action.payload
        },
        setAuthPassword:(state,action)=>{
            state.authPassWord=action.payload
        },
        get_branch_configuration_list:(state,action)=>{
            state.branchConfigurationList=action.payload
        },
        //get checkin details
        get_check_in_detail:(state,action)=>{
            state.checkInDetail=action.payload
        },
        //pass verification
        get_check_in_pass:(state,action)=>{
            state.checkInPass=action.payload
        },
        //checkout details
        get_check_out_pass_verify:(state,action)=>{
            state.checkOutPassDetail=action.payload
        },
        get_check_out:(state,action)=>{
            state.checkOutDetail=action.payload
        },
        // shiftEnd  dinomination
        get_shift_end_dinomination:(state,action)=>{
            state.shiftEndtDetail=action.payload
        }

    }
})

export const {get_products_list_for_billing,
              get_sub_category_list_for_billing,
              get_payment_types_list_for_billing,get_check_out,
              get_barcode_product_list_add_billing,get_check_out_pass_verify,
              switch_to_billing_screen,setCartProductType,get_check_in_detail,get_shift_end_dinomination,
              setBarcodeProduct,setAuthPassword,get_branch_configuration_list,get_check_in_pass
            }=newBillingSlice.actions;

export default newBillingSlice.reducer